module.exports = __webpack_public_path__ + "static/media/instructivooc8.6f857e63.png";